export default __webpack_public_path__ + "static/layla_nazif-2bbca67de22c0f86e779f2892a40018c.jpg";